const packageJson = require('../../package.json');

const CONFIG = {
    APP_NAME: 'CTRDrako',
    APP_VERSION: packageJson.version,
    BASE_URL: 'https://interventions-back.ctrdrako.fr/api',
    GALLERY_MEDIAS_DELETE_DELAY: 0,
};

export default CONFIG;